// This is its own file just so we can mock it more easily
import { extname } from 'path';
import { PartialProjectConfig } from '../../types';
import loadTypeScriptConfig from './loadTypeScriptConfig';

export default function loadConfig(configPath: string): PartialProjectConfig {
  const extension = extname(configPath);

  if (extension === '.ts') {
    return loadTypeScriptConfig(configPath);
  }

  // For .json and .js files, use the standard require
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  return require(configPath);
}
